/** Encode float samples (−1..1) to a 16-bit PCM WAV ArrayBuffer. */
export function encodeWavPcm16(
  samples: Float32Array,
  sampleRate: number,
  channels: 1 | 2 = 1,
): ArrayBuffer {
  const numFrames = channels === 2 ? Math.floor(samples.length / 2) : samples.length;
  const numSamples = numFrames * channels;
  const dataBytes = numSamples * 2;
  const buffer = new ArrayBuffer(44 + dataBytes);
  const view = new DataView(buffer);
  const blockAlign = channels * 2;

  writeString(view, 0, "RIFF");
  view.setUint32(4, 36 + dataBytes, true);
  writeString(view, 8, "WAVE");
  writeString(view, 12, "fmt ");
  view.setUint32(16, 16, true); // PCM chunk size
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, channels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * blockAlign, true); // byte rate
  view.setUint16(32, blockAlign, true);
  view.setUint16(34, 16, true); // bits
  writeString(view, 36, "data");
  view.setUint32(40, dataBytes, true);

  let offset = 44;
  for (let i = 0; i < numSamples; i++) {
    const x = Math.max(-1, Math.min(1, samples[i] ?? 0));
    view.setInt16(offset, x < 0 ? Math.round(x * 0x8000) : Math.round(x * 0x7fff), true);
    offset += 2;
  }
  return buffer;
}

export function downloadWav(buffer: ArrayBuffer, filename: string): void {
  downloadBlob(new Blob([buffer], { type: "audio/wav" }), filename);
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function writeString(view: DataView, offset: number, text: string): void {
  for (let i = 0; i < text.length; i++) {
    view.setUint8(offset + i, text.charCodeAt(i));
  }
}
